export enum BackToDestination {
  HELP_CENTER = "HELP_CENTER",
  FAIRE = "FAIRE",
}

export type BackToButtonContext = {
  label: string;
  linkTo?: string;
};
